<template>
  <v-app>
    <core-drawer />
    <core-toolbar />
    <core-view />
    <core-notification />
  </v-app>
</template>

<script>
  import { mapMutations } from 'vuex'
  import CoreToolbar from '@/components/core/Toolbar.vue'
  import CoreDrawer from '@/components/core/Drawer.vue'
  import CoreView from '@/components/core/View.vue'
  import CoreNotification from '@/components/core/Notification.vue'

  export default {
    components: {
      CoreToolbar,
      CoreDrawer,
      CoreView,
      CoreNotification
    },
    async mounted() {
      // var query = this.$route.query
      // delete query.token_type
      // delete query.access_token
      this.$router.replace({ name: this.$route.name, params: this.$route.params })

      var context = this
      this.axios.interceptors.response.use(function (config) {
        return config;
      }, function (error) {
        if (error.response.status !== 401) {
          context.$notify({
            type: 'error',
            text: error.response.data,
            max: 1
          });
        } else {
          context.$store.dispatch('clear_token')
          context.$router.push({
            path: '/login',
            query: { 
              callback: window.location.href,
              client_id: context.$store.state.credentials.client_id,
              client_secret: context.$store.state.credentials.client_secret
            }
          })
        }
        return Promise.reject(error.response);
      });

      var { data } = await this.axios.get(this.$store.state.url_api +'/authenticated')
      this.setUser(data)
    },
    methods: {
      ...mapMutations('app', ['setUser'])
    }
  }
</script>

<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
